var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { Map, Markers } from "../../Map";
import { bindActionCreators } from 'redux';
import { wrapDispatch } from "../../Multireducer";
import {
  getAndSelectDocument,
  selectDocuments,
  unselectAllDocuments } from "../actions/libraryActions";

import { SearchBar } from "./SearchBar";
import { t } from "../../I18N";

class MapViewComponent extends Component {
  constructor(props) {
    super(props);
    this.clickOnMarker = this.clickOnMarker.bind(this);
    this.clickOnCluster = this.clickOnCluster.bind(this);
  }

  clickOnMarker(marker) {
    this.props.getAndSelectDocument(marker.properties.entity.sharedId);
  }

  clickOnCluster(cluster) {
    this.props.unselectAllDocuments();
    this.props.selectDocuments(cluster.map((m) => m.properties.entity));
  }

  render() {
    const { storeKey, markers } = this.props;
    return (/*#__PURE__*/
      _jsx("div", { className: "library-map main-wrapper", style: { width: '100%', height: '100%' } }, void 0, /*#__PURE__*/
      _jsx("div", { className: "search-list" }, void 0, /*#__PURE__*/
      _jsx(SearchBar, { storeKey: storeKey })
      ), /*#__PURE__*/
      _jsx("div", { className: "documents-counter" }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx("b", {}, void 0, markers.get('totalRows')), " ", t('System', 'documents')
      )
      ), /*#__PURE__*/
      _jsx(Markers, { entities: markers.get('rows') }, void 0,
      (processedMarkers) => /*#__PURE__*/
      React.createElement(Map, {
        ref: (ref) => {
          // eslint-disable-next-line react/no-unused-class-component-methods
          this.map = ref;
        },
        markers: processedMarkers,
        clickOnMarker: this.clickOnMarker,
        clickOnCluster: this.clickOnCluster,
        renderPopupInfo: true,
        cluster: true }
      )

      )
      ));

  }
}









function mapStateToProps(state, props) {
  return {
    markers: state[props.storeKey].markers
  };
}

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators(
    { getAndSelectDocument, selectDocuments, unselectAllDocuments },
    wrapDispatch(dispatch, props.storeKey)
  );
}

const MapView = connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(
  MapViewComponent
);

export { MapViewComponent, MapView };